import React from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../Context/useAuth";
import { useForm } from "react-hook-form";

type Props = {};

type LoginFormsInputs = {
  userName: string;
  password: string;
};

const validation = Yup.object().shape({
  userName: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
});

const LoginPage = (props: Props) => {
  const { loginUser } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormsInputs>({
    resolver: yupResolver(validation),
  });

  const handleLogin = (form: LoginFormsInputs) => {
    loginUser(form.userName, form.password);
  };

  return (
    <section className="bg-lightBlue min-h-screen flex items-center justify-center">
      <div className="w-full max-w-md p-8 space-y-6 bg-black rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-white text-center">
          Sign in to your account
        </h1>
        <form className="space-y-6" onSubmit={handleSubmit(handleLogin)}>
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">
              Username
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 border border-gray-600 rounded-md bg-black text-gray-200 focus:outline-none focus:border-black"
              placeholder="Username"
              {...register("userName")}
            />
            {errors.userName && (
              <p className="mt-1 text-sm text-red-400">
                {errors.userName.message}
              </p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">
              Password
            </label>
            <input
              type="password"
              className="w-full px-4 py-2 border border-gray-600 rounded-md bg-gray-700 text-gray-200 focus:outline-none focus:border-black"
              placeholder="••••••••"
              {...register("password")}
            />
            {errors.password && (
              <p className="mt-1 text-sm text-red-400">
                {errors.password.message}
              </p>
            )}
          </div>
          <div className="flex items-center justify-between">
            <a
              href="#"
              className="text-sm font-medium text-white hover:underline"
            >
              Forgot password?
            </a>
          </div>
          <button
            type="submit"
            className="w-full py-2 px-4 text-white bg-black rounded-lg font-semibold hover:bg-pinkHighlight focus:ring-4 focus:ring-pinkHighlight focus:outline-none"
          >
            Sign in
          </button>
          <p className="text-center text-sm text-gray-400">
            Don’t have an account yet?{" "}
            <a href="register" className="font-medium text-pinkHighlight hover:underline">
              Sign up
            </a>
          </p>
        </form>
      </div>
    </section>
  );
};

export default LoginPage;
